import { CatalystInsight } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { CatalystInsightIcon } from '~/widgets/catalyst-insights-drawer/catalyst-insight-icon/CatalystInsightIcon';
import { useMarketCatalystDrawer } from '~/widgets/market-catalyst-drawer/useMarketCatalystDrawer';

import styles from './MarketCatalystCounterTooltip.module.scss';

interface MarketCatalystCounterTooltipProps {
  insights: CatalystInsight[];
  source: PosthogTrackingSource;
  onClose?: () => void;
}

export const MarketCatalystCounterTooltip = ({
  insights,
  source,
  onClose,
}: MarketCatalystCounterTooltipProps) => {
  const { t } = useTranslation(['insights']);
  const { openDrawer } = useMarketCatalystDrawer();

  return (
    <div onClick={e => e.stopPropagation()}>
      {insights.map(insight => {
        const themeId = insight.identifier;

        return (
          <div
            className={styles.tooltipWrapper}
            key={insight.id}
            onClick={() => {
              if (themeId) {
                openDrawer({
                  type: insight.sub_category,
                  themeId,
                  insightId: insight.id,
                  source,
                });
                onClose?.();
              }
            }}
          >
            <CatalystInsightIcon
              catalystInsightId={insight.id}
              category={insight.category}
              subCategory={insight.sub_category}
              size={32}
              enableHover={false}
              isBordered={false}
              identifier={themeId}
              source={source}
              isClickable={false}
            />
            <div className={styles.rightWrapper}>
              <span className={styles.tooltipTitleLabel}>
                {t('insights:catalyst.titleMarketCatalyst')}
              </span>
              {/* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events", "thematic", "geopolitical_global_events", "macroeconomic_policy_changes"] */}
              <p className={styles.categoryLabel}>
                {t(`catalyst.subcategories.${insight.sub_category}`)}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
